import { render } from "./carousel.vue?vue&type=template&id=6db6cef8&scoped=true"
import script from "./carousel.vue?vue&type=script&lang=js"
export * from "./carousel.vue?vue&type=script&lang=js"

import "./carousel.vue?vue&type=style&index=0&id=6db6cef8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db6cef8"]])

export default __exports__